import { useBooking } from '../context/BookingContext';

const MISO_MINI_IMG = 'https://customer-assets.emergentagent.com/job_heritage-prints-1/artifacts/rabix4e6_5bb4c21e-56a8-45df-88f5-ec642a498813.jpeg';

export default function Hero() {
  const { openModal } = useBooking();

  return (
    <section
      id="hero"
      data-testid="hero-section"
      style={{ backgroundColor: '#FAF5EF', position: 'relative' }}
    >
      {/* Desktop + Mobile text content */}
      <div
        className="container-miso"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '80px',
          paddingTop: '140px',
          paddingBottom: '80px',
        }}
      >
        {/* Left: Text */}
        <div style={{ flex: '1 1 0', minWidth: 0 }}>
          {/* Live badge */}
          <div className="hero-anim-0" style={{ marginBottom: '28px' }}>
            <span className="badge-live" data-testid="hero-live-badge">
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#B85C3A', flexShrink: 0 }} />
              Now available · Hyderabad
            </span>
          </div>

          {/* Headline */}
          <h1
            className="h1-miso hero-anim-1"
            data-testid="hero-headline"
            style={{ marginBottom: '24px', maxWidth: '580px' }}
          >
            Your guests will{' '}
            <span className="italic-accent" style={{ color: '#B85C3A' }}>remember this.</span>
          </h1>

          {/* Subheading — static */}
          <p
            className="hero-anim-2"
            data-testid="hero-subheading"
            style={{
              fontFamily: 'Graphik, sans-serif',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: 1.65,
              color: '#6B5D50',
              maxWidth: '460px',
              marginBottom: '20px',
            }}
          >
            Miso Mini is a premium portable photo booth for weddings, birthdays, and corporate events.
          </p>

          {/* Price */}
          <p
            className="hero-anim-2"
            data-testid="hero-price"
            style={{
              fontFamily: 'Canela, Georgia, serif',
              fontWeight: 700,
              fontSize: 'clamp(28px, 3vw, 38px)',
              color: '#2D2018',
              marginBottom: '36px',
              letterSpacing: '-0.02em',
            }}
          >
            From ₹18,000
            <span style={{ fontFamily: 'Graphik, sans-serif', fontWeight: 500, fontSize: '15px', color: '#9E8E7E', marginLeft: '10px' }}>
              · All-inclusive
            </span>
          </p>

          {/* CTA */}
          <div className="hero-anim-3" style={{ marginBottom: '20px' }}>
            <button
              onClick={openModal}
              data-testid="hero-cta-btn"
              className="btn-primary"
              style={{ fontSize: '13px', padding: '16px 36px' }}
            >
              Book Miso Mini →
            </button>
          </div>

          {/* Trust signals */}
          <div
            className="hero-anim-4"
            data-testid="hero-trust-signals"
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '16px',
              fontFamily: 'Graphik, sans-serif',
              fontWeight: 500,
              fontSize: '13px',
              color: '#9E8E7E',
            }}
          >
            {['100% advance', 'Free cancellation 7 days', 'Setup included'].map(t => (
              <span key={t} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ color: '#B85C3A', fontWeight: 700 }}>✓</span>
                {t}
              </span>
            ))}
          </div>
        </div>

        {/* Right: Image (desktop only) */}
        <div
          className="hidden md:flex"
          style={{
            flex: '0 0 480px',
            height: '580px',
            borderRadius: '20px',
            overflow: 'hidden',
            backgroundColor: '#F0E8DF',
          }}
        >
          <img
            src={MISO_MINI_IMG}
            alt="Miso Mini — premium portable photo booth"
            style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }}
          />
        </div>
      </div>

      {/* Mobile: standalone full-width image (NOT a background) */}
      <div
        className="md:hidden"
        data-testid="hero-mobile-image"
        style={{ width: '100%', height: '300px', overflow: 'hidden' }}
      >
        <img
          src={MISO_MINI_IMG}
          alt="Miso Mini photo booth"
          style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }}
        />
      </div>
    </section>
  );
}
